import { render, staticRenderFns } from "./participants.vue?vue&type=template&id=523d89d0&scoped=true"
import script from "./participants.vue?vue&type=script&lang=js"
export * from "./participants.vue?vue&type=script&lang=js"
import style0 from "./participants.vue?vue&type=style&index=0&id=523d89d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d89d0",
  null
  
)

export default component.exports